/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Indicateinterest_Title2Inputs */

const en_coinvestments_indicateinterest_title2 = /** @type {(inputs: Coinvestments_Indicateinterest_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit indicative order`)
};

/**
* | output |
* | --- |
* | "Submit indicative order" |
*
* @param {Coinvestments_Indicateinterest_Title2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_indicateinterest_title2 = /** @type {((inputs?: Coinvestments_Indicateinterest_Title2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Indicateinterest_Title2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_indicateinterest_title2(inputs)
});
export { coinvestments_indicateinterest_title2 as "coInvestments_indicateInterest_title" }